<template>
    <div class="draft-price-location-drawer" :class="{'with-n':c_hasAnyNeighbourhood}">
        <div class="d-flex justify-content-between">
            <div class="dot" v-for="(route,index) in drawRouteData.routes" :key="index">
                <span v-if="index == 0 || index == drawRouteData.routes.length - 1" class="material-icons-outlined">place</span>
                <span v-else class="material-icons-outlined">airline_stops</span>
                <span class="text text-center" :class="{'with-n':route.neighbourhood}">
                    <span class="province">{{route.province}}</span><br/>
                    <span class="district">{{route.district}}</span><br/>
                    <span class="neighbourhood" v-if="route.neighbourhood">{{route.neighbourhood}}</span>
                </span>
            </div>
        </div>
        <div class="line"></div>
        <div class="d-flex justify-content-strecth">
            <div class="text-center w-100 distance mt-50" v-for="(distance,index) in drawRouteData.distances" :key="index">
                <span>{{distance}} KM</span>
            </div>
        </div>
        <div class="text-center text-primary mt-50 total">
            Toplam {{drawRouteData.totalDistance}} KM
        </div>
    </div>
</template>

<script>
export default {
    props:{
        drawRouteData:{
            type:Object,
            required:true
        }
    },
    computed:{
        c_hasAnyNeighbourhood(){
            return this.drawRouteData.routes.some(route=>!!route.neighbourhood)
        }
    }
}
</script>

<style>
    .draft-price-location-drawer{
        padding-top: 1.3rem;
        padding-right: 2.5rem;
        padding-left: 2.5rem;
    }
    .draft-price-location-drawer.with-n{
        padding-top: 3rem;
    }
    .draft-price-location-drawer .line{
        border-bottom: 2px dashed #82868b !important;
        width: calc(100% - 4px);
        margin: 0px 2px;
    }

    .draft-price-location-drawer .dot{
        height: 32px;
        width: 32px;
        transform: translateY(18px);
        box-shadow: 0px 2px 5px 0px hsl(213, 4%, 83%) !important;
        display: flex;
        align-items: center;
        justify-content: center;
        background-color: white;
        border-radius: 50%;
        position: relative;
    }
     
    .draft-price-location-drawer .dot > span.text{
        position: absolute;
        top: -36px;
        left: 50%;
        transform: translateX(-50%);
        white-space: nowrap;
    }

    .draft-price-location-drawer .dot > span.text.with-n{
        top: -54px;
    }

    .draft-price-location-drawer .dot > span.text .province{
        font-weight: 800;
        font-size: 0.8rem;
        color: hsl(213, 4%, 43%) !important;
    }

    .draft-price-location-drawer .dot > span.text .district{
        font-weight: 500;
        font-size: 0.75rem;
        color: hsl(213, 4%, 40%) !important;
    }

    .draft-price-location-drawer .dot > span.text .neighbourhood{
        font-weight: 500;
        font-size: 0.65rem;
        color: hsl(213, 4%, 40%) !important;
    }

    .draft-price-location-drawer .distance > span{
        white-space: nowrap;
        font-size: 0.75rem;
        font-weight: bold;
        color: hsl(213, 4%, 43%) !important;
    }

    .draft-price-location-drawer{
        font-size: 0.85rem;
        font-weight: bold;
    }

</style>